/**
 * 页面数据缓存：按登录用户分开存放。
 * 进入页面先读这里渲染，请求回来再覆盖。退出登录会清空 localStorage。
 */
const PREFIX = 'okr-page-cache:'
export const PAGE_CACHE_FRESH_MS = 30 * 1000

function userId() {
  return localStorage.getItem('UserSysno') || ''
}

function storageKey(name) {
  return PREFIX + userId() + ':' + name
}

export function readPageCache(name) {
  try {
    const raw = localStorage.getItem(storageKey(name))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || !('data' in parsed)) return null
    return parsed
  } catch (e) {
    return null
  }
}

export function writePageCache(name, data) {
  try {
    localStorage.setItem(storageKey(name), JSON.stringify({
      savedAt: Date.now(),
      data: data
    }))
  } catch (e) { /* 配额满时继续用内存里的数据 */ }
}

export function isPageCacheFresh(entry, ms) {
  if (!entry || !entry.savedAt) return false
  return Date.now() - entry.savedAt < (ms || PAGE_CACHE_FRESH_MS)
}



// WEBPACK FOOTER //
// ./src/utils/pageCache.js